import { Flex, Spacer, Text } from '@chakra-ui/react';
import { useFountainPoolInfos } from '@ui/hooks/useFountainPoolInfos';
import { useReservoirPoolInfos } from '@ui/hooks/useReservoirPoolInfos';
import { useTranslations } from '@ui/i18n';
import { useDepositDrawer } from '@ui/views/Vno/ReservoirAndFountain';
import React from 'react';

import LockVnoSmallCard from '../LockVnoSmallCard';

function GardenHelpersNoWater() {
  const t = useTranslations();

  const { onOpen: openDepositDrawer } = useDepositDrawer();
  const { pools: fountainPools } = useFountainPoolInfos();
  const { pools: reservoirPools } = useReservoirPoolInfos();
  return (
    <>
      <Text textStyle={{ base: 'bodySmall', desktop: 'h4' }} textAlign="center">
        {t(
          "Your helpers won't be able to help grow your garden without water Fill up your Reservoir or Fountain to receive additional boost from your employed helpers",
        )}
      </Text>
      <Spacer mt={6} />
      <Flex gap={4}>
        <LockVnoSmallCard
          type="RESERVOIR"
          onClick={() => {
            if (reservoirPools) {
              openDepositDrawer({
                colorTheme: 'gauze',
                vaultInfo: {
                  ...reservoirPools[reservoirPools.length - 1],
                  type: 'RESERVOIR',
                  // all unused
                  status: 'UNLOCKED',
                  allocation: '0',
                  lockedStakes: [],
                  unlockedStakes: [],
                  stakeCount: 0,
                },
              });
            }
          }}
        />
        <LockVnoSmallCard
          type="FOUNTAIN"
          onClick={() => {
            if (fountainPools) {
              openDepositDrawer({
                colorTheme: 'gauze',
                vaultInfo: {
                  ...fountainPools[fountainPools.length - 1],
                  type: 'FOUNTAIN',
                  // all unused
                  status: 'UNLOCKED',
                  allocation: '0',
                  lockedStakes: [],
                  unlockedStakes: [],
                  stakeCount: 0,
                },
              });
            }
          }}
        />
      </Flex>
    </>
  );
}

export default GardenHelpersNoWater;
